import React from 'react';
import { Form } from 'formik';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import OwnerRegistrationStep from './OwnerRegistrationStep';
import OtherUsersStep from './OtherUsersStep';
import EssentialAccountOrganizationDetailsStep from './EssentialAccountOrganizationDetailsStep';
import { AccountType } from '../../../shared/Constants';

const EssentialAccountInvitationForm = ({ invitation, countries, locales, timeZones, taxIds, token, userExists }) => {
  const { path } = useRouteMatch();

  const {
    cldr: { localeDisplayName, teritoryDisplayNames },
  } = useSelector((state) => state.i18n);

  const { availableRoles } = invitation;

  const userRegistrationCountryOptions = teritoryDisplayNames(countries);
  const companyCountryOptions = teritoryDisplayNames(countries);
  const supportedLanguages = locales.map((lang) => ({
    value: lang,
    label: localeDisplayName(lang),
  }));
  const availableTimeZones = timeZones.map((timeZone) => ({
    value: timeZone,
    label: timeZone,
  }));
  const taxIdOptions = taxIds.map((taxId) => ({
    value: taxId.id,
    label: `${taxId.country} - ${taxId.description}`,
  }));

  return (
    <Form>
      <Switch>
        <Route
          exact
          path={`${path}`}
          component={() => {
            if (userExists) {
              return (
                <EssentialAccountOrganizationDetailsStep
                  invitation={invitation}
                  countries={companyCountryOptions}
                  availableTaxIds={taxIds}
                  taxIdOptions={taxIdOptions}
                  token={token}
                  userExists={userExists}
                />
              );
            } else {
              return (
                <OwnerRegistrationStep
                  countries={userRegistrationCountryOptions}
                  locales={supportedLanguages}
                  timeZones={availableTimeZones}
                  token={token}
                />
              );
            }
          }}
        />
        <Route
          exact
          path={`${path}/organisation-details`}
          component={() => (
            <EssentialAccountOrganizationDetailsStep
              invitation={invitation}
              countries={companyCountryOptions}
              availableTaxIds={taxIds}
              taxIdOptions={taxIdOptions}
              token={token}
              userExists={userExists}
            />
          )}
        />
        <Route
          exact
          path={`${path}/other-users`}
          component={() => <OtherUsersStep type={AccountType.ESSENTIAL} availableRoles={availableRoles} />}
        />
      </Switch>
    </Form>
  );
};

export default EssentialAccountInvitationForm;
